import { InjectionToken } from '@angular/core';
import { AuthProvider } from '@data/auth/AuthProvider';

export let AUTH_PROVIDER: InjectionToken<AuthProvider> = new InjectionToken<AuthProvider>('auth-provider');